import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInitialState, updateBranchLocationOption } from './branchLocationDetailsSlice';
import Loader from '../../components/loader';

// Same four values the four hand-written cards dispatched before.
const LOCATION_OPTIONS = [
    'Existing Location with Lease',
    'Existing Location without Lease',
    'Plan on getting location',
    'No location / virtual location',
];

const BranchLocationOption = () => {
    const selected = useSelector(state => state.branch_location);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchInitialState())
    }, [dispatch])

    return (
    <>
        { selected.loading && <Loader /> }
        <div className="mt-4 flex flex-col items-center justify-center sm:mt-10">
            <h3 className="text-center text-2xl font-bold tracking-tight text-[#0a1445] sm:text-3xl">
                Select the option that best matches your Location
            </h3>

            <div className="mt-8 grid w-full max-w-4xl grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
                {LOCATION_OPTIONS.map(optionValue => {
                    const isSelected = selected.data._option === optionValue;
                    return (
                        <button
                            key={optionValue}
                            type="button"
                            onClick={() => dispatch(updateBranchLocationOption(optionValue))}
                            className={`relative flex min-h-[64px] items-center justify-center rounded-2xl border px-4 py-4 text-center text-sm font-semibold transition-all sm:min-h-[132px] sm:text-base ${isSelected ? 'border-[#fb6635] bg-orange-50 text-[#211b4f] ring-1 ring-[#fb6635]' : 'border-slate-200 bg-white text-slate-600 shadow-sm hover:border-orange-200 hover:bg-orange-50/40'}`}
                        >
                            <p>{optionValue}</p>
                            {isSelected && (
                                <span className="absolute right-2 top-2 text-[#fb6635]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-check-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                        <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                                    </svg>
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>

        </div>
    </>
  )
}

export default BranchLocationOption;
